import _orderByTime from "./orderByTime.js";
const orderByTime = _orderByTime;
export default (function fixOverlap(eventGroup, frameGap, frameRate) {
  eventGroup = orderByTime(eventGroup);
  for (let eventCount = 0; eventCount < eventGroup.events.length - 1; eventCount++) {
    let currentEvent = eventGroup.events[eventCount],
      nextEvent = eventGroup.events[eventCount + 1],
      frameGapInSeconds = frameGap > 0 && frameRate ? frameGap / frameRate : 0;
    if (nextEvent.start < currentEvent.end + frameGapInSeconds) {
      let currentEnd = nextEvent.start - frameGapInSeconds,
        nextStart = currentEvent.end + frameGapInSeconds,
        currentDuration = currentEnd - currentEvent.start,
        nextDuration = nextEvent.end - nextStart;
      if (nextDuration > currentDuration) {
        nextEvent.start = nextStart;
      } else {
        currentEvent.end = currentEnd;
      }
    }
  }
  return eventGroup;
});